const firebaseConfig = {
    apiKey: "AIzaSyAucXI42w4gOrLX80Imn3NErCbtxOiZrA0",
    authDomain: "loginapp1995.firebaseapp.com",
    databaseURL: "https://loginapp1995.firebaseio.com",
    projectId: "loginapp1995",
    storageBucket: "loginapp1995.appspot.com",
    messagingSenderId: "1071473065169",
    appId: "1:1071473065169:web:c8e07d44a0a213707fd9f0"
  };
export default firebaseConfig;